import { formatAsPrice } from "./format";

export const getPlanMonthlyPrice = (price: number | string | undefined) => {
  if (price == null) {
    return "Not available";
  }
  // Explicitly check for zero (both numeric 0 and string "0")
  if (price === 0 || price === "0") {
    return "Free";
  }
  let monthlyPrice: string | number = price;
  monthlyPrice = typeof price === "string" ? price : formatAsPrice(price);
  if (monthlyPrice === "contact") {
    monthlyPrice = "Contact Us";
  }

  return monthlyPrice || "Not available";
};
